const BETA_PARAM = 'beta'
const BETA_OPT_IN = 'true'
const ABSOLUTE_URL = /^[a-z][a-z\d+.-]*:/i

// The Ruby route fork serves a migrated page as Vue 3 only when a full page load carries
// params[:beta] == 'true', so any link or navigation that drops it silently lands on Vue 2.
export function isBetaOptIn(query: Record<string, unknown> = {}) {
  const beta = query[BETA_PARAM]
  return Array.isArray(beta) ? beta.includes(BETA_OPT_IN) : beta === BETA_OPT_IN
}

export function betaOptIn(query: Record<string, unknown> = {}) {
  return { [BETA_PARAM]: isBetaOptIn(query) ? BETA_OPT_IN : undefined }
}

export function withBetaOptIn(url: string) {
  const link = new URL(url, window.location.origin)
  link.searchParams.set(BETA_PARAM, BETA_OPT_IN)
  return ABSOLUTE_URL.test(url) ? link.toString() : `${link.pathname}${link.search}${link.hash}`
}

/** A link out of the current page keeps the beta opt-in only when the page itself was opened with it. */
export function keepingBetaOptIn(url: string) {
  const pageQuery = Object.fromEntries(new URLSearchParams(window.location.search))
  return isBetaOptIn(pageQuery) ? withBetaOptIn(url) : url
}
